import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    Paper,
    TableBody,
    Typography
} from '@mui/material';

const CB_BIOCHAR_MASS_HEADERS = [
    'Project ID',
    'Batch ID',
    'CB ID',
    'Total Volume Average',
    'Bulk Density Average',
    'Biochar Pile Count',
    'Biochar Mass',
    'Unit'
]

export default function CbBiocharMass({ loading, biocharMass }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">Biochar Mass</Typography>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {CB_BIOCHAR_MASS_HEADERS.map((header) => (
                                <TableCell
                                    key={header}
                                    align='left'
                                >
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading
                            ? <Typography>Loading...</Typography>
                            : biocharMass?.map((bm, index) => (
                                <TableRow key={index}>
                                    <TableCell align="left">{bm.projectId}</TableCell>
                                    <TableCell align="left">{bm.batchId}</TableCell>
                                    <TableCell align="left">{bm.cbId}</TableCell>
                                    <TableCell align="left">{bm.totalVolumeAverage === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : bm.totalVolumeAverage.toFixed(3)}</TableCell>
                                    <TableCell align="left">{bm.averageBulkDensity.toFixed(3)}</TableCell>
                                    <TableCell align="left">{bm.biocharPileCount}</TableCell>
                                    <TableCell align="left">{bm.biocharMass === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : bm.biocharMass.toFixed(3)}</TableCell>
                                    <TableCell align="left">{bm.unit}</TableCell>
                                    {/* <TableCell align="left">
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            placeholder="Enter value"
                                                            type="number"
                                                            fullWidth
                                                            value={bm.airCorrectionFactor}
                                                            onChange={(e) => handleAirCorrrectionFactorChange(e, bm.id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            placeholder="Enter value"
                                                            type="number"
                                                            fullWidth
                                                            value={bm.charCorrectionFactor}
                                                            onChange={(e) => handleCharCorrrectionFactorChange(e, bm.id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="left">{bm.totalVolumeAverage === null ? <Typography sx={{ color: 'darkorange' }}>Correction Factors not defined</Typography> : bm.totalVolumeAverage}</TableCell>
                                                    <TableCell align="left">{bm.averageBulkDensity}</TableCell> */}
                                </TableRow>
                            )
                            )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
